var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.track)?_c('TrackSidebarMetadataTab',{attrs:{"track":_vm.track}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }